var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircular = function SvgCheckCircular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m3.836 5.546L7.47 10.733l-1.417-1.53a.79.79 0 0 0-.98-.045.686.686 0 0 0-.202.9l1.688 2.756a.94.94 0 0 0 .776.405.92.92 0 0 0 .765-.405c.27-.349 5.423-6.503 5.423-6.503.675-.675-.147-1.293-.675-.765z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckCircular;